<div *ngIf="!mostrarFormulario" class="row animated fadeInRight">
  <!-- *GRID LISTAR ROL -->
  <app-lfsa-card-v2 *ngIf="mostrarGridLista"
                    [innTemplate]="enviarTemplate" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #enviarTemplate>
    <section class="section">
      <form [formGroup]="formulario" class="form-group" novalidate>
        <div class="row">
          <div class="form-group col-md-6">
            <div class="btn-group btn-group-toggle" data-toggle="buttons">
              <label class="btn btn-secondary active">
                <input (change)="revision('mont')" autocomplete="off" checked id="option1" name="options" type="radio">
                Mensual
              </label>
              <label class="btn btn-secondary">
                <input (change)="revision('week')" autocomplete="off" id="option2" name="options" type="radio"> Semanal
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <app-lfsa-combo-box (change)="listAll()"
                                (change)="changeYear()"
                                [comboBox]="cmbYears"
                                [control]="formulario.get('year') | formControl"
                                [idOpcion]="'id'" [id]="'year'" [label]="'Año*'"
                                [opcion]="'descripcion'"
                                formControlName="year">
            </app-lfsa-combo-box>
          </div>
          <div class="form-group col-md-6">
            <app-lfsa-combo-box (change)="listAll()" *ngIf="mont"
                                [comboBox]="cmbWeeks"
                                [control]="formulario.get('week') | formControl"
                                [idOpcion]="'id'" [id]="'week'" [label]="'Mes*'"
                                [opcion]="'descripcion'"
                                formControlName="week">
            </app-lfsa-combo-box>
            <app-lfsa-combo-box (change)="listAll()" *ngIf="week"
                                [comboBox]="cmbWeeks"
                                [control]="formulario.get('week') | formControl"
                                [idOpcion]="'id'" [id]="'week'" [label]="'Semana*'"
                                [opcion]="'descripcion'"
                                formControlName="week">
            </app-lfsa-combo-box>
          </div>
        </div>
        <!--        <div class="row">
                  <div class="form-group col-md-6">
                    <app-lfsa-combo-box
                      (change)="listAll()"
                      [comboBox]="cmbEmployees"
                      [control]="formulario.get('id') | formControl"
                      [idOpcion]="'id'" [id]="'id'" [label]="'Cedula*'"
                      [opcion]="'descripcion'"
                      formControlName="id">
                    </app-lfsa-combo-box>
                  </div>
                  <div class="form-group col-md-6">
                    <app-lfsa-combo-box
                      (change)="listAll()"
                      [comboBox]="cmbDepartment"
                      [control]="formulario.get('department') | formControl"
                      [idOpcion]="'id'" [id]="'department'" [label]="'Departamento'"
                      [opcion]="'descripcion'"
                      formControlName="department">
                    </app-lfsa-combo-box>
                  </div>
                </div>-->
        <div *ngIf="formulario.valid" class="row mb-2">
          <div class="form-group col-md-6">
            <button (click)="descargarExcel()" class="btn btn-success btn-block">Descargar Excel</button>
          </div>
          <div class="form-group col-md-6">
            <button (click)="getAllHorasExtraReport()" class="btn btn-success btn-block">Descargar Excel Turnos vs
              Marcación
            </button>
          </div>
        </div>
        <div *ngIf="formulario.valid && this.isRoleAprobacionNivel1" class="row mb-4">
          <div class="form-group col-md-6">
            <button (click)="cargarAprobacion()" class="btn btn-info btn-block">Aprobar Horas Extras</button>
          </div>
        </div>
      </form>
      <div *ngIf="formulario.valid" class="row">
        <div class="col-md-12 ">
          <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
          <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [columnDefs]="columnDefs"
                           [floatingFilter]="true" [frameworkComponents]="frameworkComponents"
                           [isRowSelectable]="isRowSelectable" [ngStyle]="diccionarioModulo.agGrid.style"
                           [pagination]="true" [rowData]="rowData"
                           [rowSelection]="rowSelection"
                           [suppressRowClickSelection]="true"
                           class="{{diccionarioModulo.agGrid.class}}" id="{{diccionarioModulo.agGrid.id}}"
                           [paginationPageSize]="diccionarioModulo.agGrid.paginacion">
          </ag-grid-angular>
        </div>
      </div>
    </section>
  </ng-template>
</div>
